<template>
  <div>
    <div v-if="isCheckingPromo" class="columns">
      <div class="column is-12-mobile is-12-desktop is-12-widescreen">
        <div class="title is-marginless is-paddingless">Checking promotion options
          <span :class="[{ 'is-loading': isCheckingPromo }, 'button is-white has-text-right preloader']"></span>
        </div>
      </div>
    </div>
    <div v-if="selectPackageView && !isCheckingPromo">
      <div class="columns">
        <div class="column">
          <div class="level">
            <div class="level-left">
              <h1 v-if="!isPromoPage" class="title">Renew your subscription</h1>
              <h1 v-if="isPromoPage" class="title">Upgrade your subscription</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div v-if="!isPromoPage" class="column">
          <p class="has-text-left-tablet has-text-centered-mobile">Choose your package.</p>
          <p class="has-text-left-tablet has-text-centered-mobile">For more information about each package, view our <a target="_blank" href="https://biz.hellopeter.com/plans">package breakdown</a>.</p>
        </div>
        <div v-if="isPromoPage" class="column">
          <p class="has-text-left-tablet has-text-centered-mobile">Upgrade to one of our premium packages and get 30% off. For more information about each package, view our <a target="_blank" href="https://biz.hellopeter.com/plans">package breakdown</a>.</p>
        </div>
      </div>
      <div v-if="isPromoPage" class="columns">
        <div class="column">
          <p class="has-text-left-tablet has-text-centered-mobile has-text-weight-bold">Which package would you like to upgrade to?</p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-3-tablet is-2-desktop">
          <package-card :is-promo="isPromoPage" title="Lite" :cost="liteCost" package-type="lite" :show-logo-and-body="packing_listing_logo"></package-card>
          <div class="has-text-centered margin-top-20">
            <input type="radio" name="package" value="lite" v-model="selected_package" />
          </div>
        </div>
        <div class="column is-3-tablet is-2-desktop">
          <package-card :is-promo="isPromoPage" title="Pro" :cost="proCost" package-type="pro" :show-logo-and-body="packing_listing_logo"></package-card>
          <div class="has-text-centered margin-top-20">
            <input type="radio" name="package" value="pro" v-model="selected_package" />
          </div>
        </div>
        <div class="column is-3-tablet is-2-desktop">
          <package-card :is-promo="isPromoPage" title="Enterprise" :cost="enterpriseCost" package-type="enterprise" :show-logo-and-body="packing_listing_logo"></package-card>
          <div class="has-text-centered margin-top-20">
            <input type="radio" name="package" value="enterprise" v-model="selected_package" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <span class="info-display has-text-weight-semibold is-size-6 margin-top-20">Payment method</span>
            <div>
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="payment_method" value="CREDIT_CARD" v-model="form.payment_method" />&nbsp;&nbsp;&nbsp;Credit Card
              </label>
            </div>
            <div>
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="payment_method" value="EFT" v-model="form.payment_method" />&nbsp;&nbsp;&nbsp;EFT
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showPaymentFrequency" class="columns">
        <div class="column">
          <div class="field">
            <span class="info-display has-text-weight-semibold is-size-6 margin-top-20">Payment frequency</span>
            <div>
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="payment_frequency" value="MONTHLY" v-model="payment_frequency" />&nbsp;&nbsp;&nbsp;Monthly
              </label>
            </div>
            <div>
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="payment_frequency" value="ANNUAL" v-model="payment_frequency" />&nbsp;&nbsp;&nbsp;Annual
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showLiteBreakdown" class="columns">
        <div class="column">
          <div class="field">
            <span class="info-display has-text-weight-semibold is-size-6 margin-top-20">First payment amount</span>
            <div>
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="pro_rata_option" value="1" v-model="pro_rata_option" /><span>&nbsp;&nbsp;&nbsp;</span><span>R{{ pro_rata_and_next_month }}&nbsp;<span class="is-size-7">(pro rata and next month's payment)</span></span>
              </label>
            </div>
            <div v-if="can_choose_pro_rata_options">
              <label class="radio is-size-6 label-filters">
                <input type="radio" name="pro_rata_option" value="0" v-model="pro_rata_option" /><span>&nbsp;&nbsp;&nbsp;</span><span>R{{ pro_rata_only }}&nbsp;<span class="is-size-7">(pro rata amount only)</span></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="enableNextButton" class="columns">
        <div class="column is-3-tablet is-2-desktop is-offset-6-tablet is-offset-4-desktop is-hidden-mobile">
          <button class="button is-button-blue is-fullwidth" @click.prevent="nextButtonClicked">NEXT</button>
        </div>
        <div class="column is-hidden-tablet">
          <button class="button is-button-blue is-fullwidth" @click.prevent="nextButtonClicked">NEXT</button>
        </div>
      </div>
    </div>
    <!-- BILLING INFO VIEW -->
    <div v-if="selectBillingInfoView && !isCheckingPromo">
      <div class="columns">
        <div class="column is-4-tablet is-3-desktop">
          <package-card :title="selected_package_friendly_name" :cost="package_amount" :package-type="selected_package">
          </package-card>
        </div>
        <div class="column is-8-tablet is-6-desktop">
          <div class="payment-method">
            <div class="title is-size-4">{{billing_info_title}}</div>
            <span class="is-size-7 sub">Confirm your billing information</span>
            <div v-for="billing in billing_information">
              <div v-for="(section, heading) in billing">
                <div class="control">
                  <div v-for="(element, index) in section" class="field" v-if="section[index].type === 'text'">
                    <input
                            :ref="`${section[index].element_name}`"
                            class="input"
                            type="text"
                            v-model="form[`${section[index].element_name}`]"
                            :name="`${section[index].element_name}`"
                            :placeholder="`${section[index].name}`" />
                  </div>
                  <!-- address -->
                  <div v-else-if="section[index].type === 'address'" class="control">
                    <input
                      :ref="`${section[index].element_name}`"
                      class="input"
                      type="text"
                      v-model="form[`${section[index].element_name}`]"
                      :name="`${section[index].element_name}`"
                      :placeholder="`${section[index].name}`" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns margin-top-20">
              <div class="column is-marginless no-left-pad">
                <div class="has-text-right-desktop has-text-right-tablet">
                  <button
                          class="button is-button-blue is-fullwidth"
                          :class="[{ 'is-loading': is_sending}]"
                          @click.prevent="showPackageSelectionView">< BACK
                  </button>
                </div>
              </div>
              <div class="column is-marginless no-right-pad">
                <div class="has-text-right-desktop has-text-right-tablet">
                  <button
                          class="button is-button-blue is-fullwidth is-fullwidth"
                          :class="[{ 'is-loading': is_sending}]"
                          @click.prevent="sendBillingInfo"
                          :disabled="!enableSubmitBillingInfo">PROCEED TO PAYMENT
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import qs from 'qs'
  import PackageCard from './../card/PackageCard.vue'
  import PackageMixinData from './../../mixins/onboarding-package-forms.js'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import ApiResource from './../../api/ApiResource.js'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Renew your subscription'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Renew your subscription'
      })
    },
    name: 'RenewPackage',
    props: {
      userHash: {
        type: String,
        default: ''
      }
    },
    components: {
      PackageCard,
      VueGoogleAutocomplete
    },
    mixins: [
      PackageMixinData
    ],
    created () {
      const savedBillingDetails = localStorage.getItem('billingDetails')
      this.getLiteMonthlyProRataDetails()
      if (typeof savedBillingDetails === 'undefined' || savedBillingDetails === null) {
        const businessSlug = localStorage.getItem('org_slug')
        axios.get(`/${businessSlug}/billing-details`)
          .then(({data}) => {
            localStorage.setItem('billingDetails', JSON.stringify(data))
            this.setBillingFields()
          })
      }
      if (typeof savedBillingDetails !== 'undefined' && savedBillingDetails !== null) {
        this.setBillingFields()
      }

      const promoHash = this.userHash.trim()
      if (promoHash.length > 0) {
        const currentOrgId = localStorage.getItem('org_id')
        this.isPromoPage = currentOrgId === promoHash
        this.verifyAccessToPromoPackages()
      }

      if (this.$route.query.flash) {
        flash(this.$route.query.flash, 'is-warning') // assume that flash message on load is a warning or error
      }
    },
    data () {
      return {
        isPromoPage: false,
        isCheckingPromo: false,
        expires: '',
        now: moment(),
        packing_listing_logo: false,
        is_sending: false,
        billingDetails: {},
        billingPaymentFrequency: 'ANNUAL',
        payment_method: '',
        selected_package: '',
        current_package: '',
        selected_package_friendly_name: 'Lite',
        payment_frequency: '',
        package_amount: '',
        selectPackageView: true,
        selectBillingInfoView: false,
        pro_rata_and_next_month: undefined,
        pro_rata_only: undefined,
        can_choose_pro_rata_options: false,
        pro_rata_option: 1,
        form: new ApiResource({
          business_id: localStorage.getItem('org_id'),
          org_lat: 0.00,
          org_lng: 0.00,
          business_reg_number: '',
          business_reg_name: '',
          payment_freq: 'ANNUAL',
          payment_method: 'CREDIT_CARD',
          selected_package: '',
          business_vat_number: '',
          address: '',
          select_pro_rata_and_next_month: 1,
          is_promo: false
        })
      }
    },
    computed: {
      liteCost () {
        if (this.isPromoPage) {
          return '<br/>Was R8,388.00 pa<br/>Now R5,871.00 pa<br/><br/><span class="has-text-weight-bold">You save R2,518</span>'
        }
        if (this.showPaymentFrequency && this.payment_frequency === 'MONTHLY') {
          return 'R699.00 pm'
        }
        return 'R8,388.00 pa'
      },
      proCost () {
        if (this.isPromoPage) {
          return '<br/>Was R31,118.00 pa<br/>Now R21,782.00 pa<br/><br/><span class="has-text-weight-bold">You save R9,336</span>'
        }
        return 'R31,118.00 pa'
      },
      enterpriseCost () {
        if (this.isPromoPage) {
          return '<br/>Was R95,988.00 pa<br/>Now R67,191.00 pa<br/><br/><span class="has-text-weight-bold">You save R28,797</span>'
        }
        return 'R95,988.00 pa'
      },
      showPaymentFrequency () {
        return this.selected_package === 'lite' && !this.isPromoPage && !((this.current_package === 'lite' || this.current_package === 'lite (monthly)') && this.billingPaymentFrequency === 'MONTHLY')
      },
      showLiteBreakdown () {
        const isFree = this.current_package === 'free'
        const selectedLite = this.showPaymentFrequency
        const selectedMonthly = this.payment_frequency !== null && this.payment_frequency === 'MONTHLY'
        return isFree && selectedLite && selectedMonthly && !this.isPromoPage
      },
      paymentMethodSelected () {
        return this.form.payment_method !== null && this.form.payment_method.length > 0
      },
      paymentFrequencySelected () {
        return this.payment_frequency !== null && this.payment_frequency.length > 0
      },
      packageSelected () {
        return this.selected_package !== null && this.selected_package !== 'free' && this.selected_package.length > 0
      },
      enableNextButton () {
        const hasMethod = this.paymentMethodSelected
        const hasPackage = this.packageSelected
        const hasFrequency = this.paymentFrequencySelected
        const shouldShowFrequency = this.showPaymentFrequency

        return hasPackage && hasMethod && (!shouldShowFrequency || hasFrequency)
      },
      enableSubmitBillingInfo () {
        return this.form.business_reg_name !== null && this.form.business_reg_name.length > 0 &&
          this.form.address !== null && this.form.address.length > 0
      }
    },
    watch: {
      selected_package () {
        this.form.selected_package = this.selected_package
        switch (this.selected_package) {
          case 'pro':
            this.selected_package_friendly_name = 'Pro'
            this.package_amount = this.proCost
            this.payment_frequency = 'ANNUAL'
            break
          case 'enterprise':
            this.selected_package_friendly_name = 'Enterprise'
            this.package_amount = this.enterpriseCost
            this.payment_frequency = 'ANNUAL'
            break
          default:
            this.selected_package_friendly_name = 'Lite'
            this.package_amount = this.liteCost
            break
        }
      },
      payment_frequency () {
        this.form.payment_freq = this.payment_frequency
        if (this.selected_package === 'lite') {
          if (this.payment_frequency === 'MONTHLY') {
            this.package_amount = 'R699.00 pm'
          } else {
            this.package_amount = 'R8,388.00 pa'
          }
        }
      },
      pro_rata_option () {
        this.form.select_pro_rata_and_next_month = this.pro_rata_option
      }
    },
    methods: {
      showPackageSelectionView () {
        this.selectPackageView = true
        this.selectBillingInfoView = false
      },
      nextButtonClicked () {
        this.selectPackageView = false
        this.selectBillingInfoView = true
      },
      getAddressData: function (addressData, placeResultData, id) {
        this.form.address = placeResultData.formatted_address
        this.form.org_lng = addressData.longitude
        this.form.org_lat = addressData.latitude
      },
      sendBillingInfo () {
        this.is_sending = true
        const paymentMethod = this.form.payment_method === 'CREDIT_CARD' ? 'card' : 'eft'
        this.form.is_promo = this.isPromoPage
        this.form.send(`/subscriptions/upgrade-or-renew`)
          .then((response) => {
            this.is_sending = false
            if (typeof response.invoice !== 'undefined') {
              const invoice = response.invoice.id
              this.$router.push(`/renew-or-upgrade-subscription/${paymentMethod}/${invoice}/`)
            }
          })
          .catch((error) => {
            this.is_sending = false
            console.log('error', error)
          })
      },
      getLiteMonthlyProRataDetails () {
        axios.get('/onboarding/lite/pro-rate')
          .then(({data}) => {
            if (typeof data.can_have_prorata_on_own_invoice !== 'undefined') {
              if (this.isPromoPage) {
                this.can_choose_pro_rata_options = false
              } else {
                this.can_choose_pro_rata_options = data.can_have_prorata_on_own_invoice
              }
            }
            if (typeof data.inclusive_amount !== 'undefined') {
              this.pro_rata_and_next_month = data.inclusive_amount
            }
            if (typeof data.pro_rated_amount !== 'undefined') {
              this.pro_rata_only = data.pro_rated_amount
            }
          })
      },
      setBillingFields () {
        const savedBillingDetails = localStorage.getItem('billingDetails')
        if (typeof savedBillingDetails !== 'undefined') {
          this.billingDetails = JSON.parse(savedBillingDetails)
          this.billingPaymentFrequency = this.billingDetails.payment_plan.frequency
          this.current_package = this.selected_package = this.form.selected_package = this.billingDetails.subscription.name.toLowerCase()
          this.form.payment_method = this.billingDetails.payment_plan.payment_method
          this.payment_frequency = 'ANNUAL'
          this.form.business_reg_number = this.billingDetails.billing_details.registration_number
          this.form.business_reg_name = this.billingDetails.billing_details.registered_name
          this.form.business_vat_number = this.billingDetails.billing_details.vat_number
          this.form.address = this.billingDetails.billing_details.billing_address
          this.form.org_lat = 0.0000
          this.form.org_lng = 0.0000
          this.expires = this.billingDetails.subscription.expires
          this.shouldRedirectToHomePage()
        }
      },
      shouldRedirectToHomePage () {
        let mustNotSeeThisPage = false
        if (typeof this.current_package !== 'undefined' && !(this.current_package.toLowerCase().indexOf('free') !== -1)) {
          // should have force_upgrade as query string if paid subscription biz want to upgrade its package before 60 days
          if (this.expires.length > 0 && !this.$route.query.hasOwnProperty('force_upgrade')) {
            const expires = moment(this.expires)
            mustNotSeeThisPage = expires.diff(this.now, 'days') > 60
          }
        }

        if (mustNotSeeThisPage) {
          this.$router.push('/')
        }
      },
      verifyAccessToPromoPackages () {
        this.isCheckingPromo = true
        const businessSlug = localStorage.getItem('org_slug')
        axios.get(`/subscriptions/${businessSlug}/promo/qualifies`)
          .then(() => {
            this.isCheckingPromo = false
          })
          .catch((error) => {
            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.message !== 'undefined') {
              const queryMsg = qs.stringify({flash: error.response.data.message})
              window.location.href = `/renew-or-upgrade-subscription?${queryMsg}`
            }
          })
      }
    }
  }
</script>
<style scoped>
  span.info-display {
    display: block;
    margin-bottom: 10px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .label-filters {
    color: #58595b;
  }

  .no-left-pad {
    padding-left: 0;
  }

  .no-right-pad {
    padding-right: 0;
  }

  @media screen and (max-width: 767px) {
    .columns > .column {
      margin-left: 30px;
      margin-right: 30px;
    }

    .card {
      margin-left: 0!important;
      margin-right: 0!important;
    }

    .no-left-pad, .no-right-pad {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/RenewPackage.vue